export default {
	methods: {
		/**
		 * Verifica se o valor contém código de erro.
		 * @param {string} value - O valor a ser verificado.
		 * @returns {boolean} - True se contém "error", false caso contrário.
		 */
		hasErrorCode(value) {
			return value?.includes("error") || false;
		},

		/**
		 * Verifica se a validade do tipo Date (ValidityType.Date = 2) é válida (data de validade preenchida quando necessário).
		 * @param {object} requirement - O objeto do requisito.
		 * @param {object} requirementResponseData - Os dados da resposta do requisito.
		 * @returns {boolean} - True se válido, false se inválido.
		 */
		isValidityTypeDateValid(requirement, requirementResponseData) {
			if (
				requirement.validityType === this.$ValidityType.Date &&
				!this.hasErrorCode(requirementResponseData.answer) &&
				(requirementResponseData.validityDate === null || requirementResponseData.validityDate === "")
			) {
				return false;
			}
			return true;
		},

		/**
		 * Verifica se o score é válido (obrigatório e preenchido quando AllowScore está habilitado).
		 * @param {object} requirementResponseData - Os dados da resposta do requisito.
		 * @param {object} configurations - As configurações do sistema.
		 * @returns {boolean} - True se válido, false se inválido.
		 */
		isScoreValid(requirementResponseData, configurations) {
			if (
				configurations.AllowScore &&
				(requirementResponseData?.scoreValue == null || requirementResponseData?.scoreValue === "")
			) {
				return false;
			}

			if (requirementResponseData?.scoreValue < 0 || requirementResponseData?.scoreValue > 10) {
				return false;
			}

			return true;
		},

		/**
		 * Valida todos os campos em requirementResponseCrudStructure.
		 * @param {array} requirementResponseCrudStructure - A estrutura CRUD dos campos.
		 * @param {object} requirementResponseData - Os dados da resposta do requisito.
		 * @returns {boolean} - True se todos os campos forem válidos, false se algum falhar.
		 */
		validateCrudFields(requirementResponseCrudStructure, requirementResponseData) {
			for (let index = 0; index < requirementResponseCrudStructure.length; index++) {
				const field = requirementResponseCrudStructure[index];
				if (field.validation) {
					const isValid = field.validation.rule(requirementResponseData[field.name]);
					if (!isValid) {
						return false;
					}
				}
			}
			return true;
		}
	}
};
